module.exports = __webpack_public_path__ + "static/img/RALZF_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RALZF_1.png
// module id = Pdmp
// module chunks = 0